const DDHAPPS_EMAIL_DOMAIN = '@ddhapps.com';

export function isDdhappsAccount(user) {
  return !!user?.email && user.email.toLowerCase().endsWith(DDHAPPS_EMAIL_DOMAIN);
}

export function landingRouteFor(user) {
  return isDdhappsAccount(user) ? '/admin' : '/account';
}
